import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

const ArrowIcon = props => {
  const { colors } = useContext(ThemeContext);
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="19"
      viewBox="0 0 33 19"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M8.5 1.5v16h16v-16z" />
        <path
          fill={colors.white}
          d="M14.911 17.594L1.405 4.084a2.255 2.255 0 0 1 0-3.178 2.253 2.253 0 0 1 3.178 0L16.5 12.826 28.417.906a2.253 2.253 0 0 1 3.178 0 2.255 2.255 0 0 1 0 3.178l-13.506 13.51a2.253 2.253 0 0 1-3.178 0z"
        />
      </g>
    </svg>
  );
};

export default ArrowIcon;
